import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import client from '../../api/client';
import formatDate from '../../utils/formatDate';
import B1 from './B1';
import B2 from './B2';
import B3 from './B3';
import Spinner from '../Global/Spinner';
import { useUser } from '../../context/UserContext';

const BlogPost = () => {
	const [post, setPost] = useState({});
	const { user } = useUser();
	const { id } = useParams();

	const fetchPost = async () => {
		const { data } = await client.get(`/blog/${id}`);
		if ({ data }) {
			setPost({
				...data.post,
			});
		}
		return;
	};

	useEffect(() => {
		fetchPost();
	}, [id]);

	const randomType = Math.floor(Math.random() * 3); // Generates a random integer between 0 and 2
	let components = [];
	// if (user && user.isAdmin) {
	// 	components.push(<EnhanceButton />);
	// }
	switch (randomType) {
		case 0:
			return (
				<B1
					post={post}
					setPost={setPost}
				/>
			);

		case 1:
		// return (
		// 	<B2
		// 		post={post}
		// 		setPost={setPost}
		// 	/>
		// );

		case 2:
			return (
				<B3
					post={post}
					setPost={setPost}
				/>
			);

		default:
			return;
	}
};
export default BlogPost;
